export default theme => ({
  container: {
    textAlign: 'right',
  },
});
